module.exports = __webpack_public_path__ + "media/images/icons/country_flags/bv-3d8e6f49fad8459575e1ffe4580f7ada.svg";